import * as React from 'react';
import CalendarLtrRegular from 'mini-fluent-svg-icons/lib/icons/CalendarLtrRegular';
import { FluentSvgIcon } from 'mini-fluent-svg-icons/lib/components/FluentSvgIcon';

const styles = require('./CalendarIcon.scss');

/**
 * Returns the calendar svg when the calendar module is not selected
 */
export const CalendarIconDefault = React.forwardRef(
    (props: any, ref: React.RefObject<any>): JSX.Element => (
        <FluentSvgIcon ref={ref} icon={CalendarLtrRegular} iconStyles={styles.calendarModuleSVG} />
    )
);
